import * as styles from "./PageHeader.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Icon } from "@frontend/components/atoms/Icon";

import type { PageHeaderVisualProps } from "./PageHeader.types";

export function PageHeaderVisual({
  icon,
  variant = "card",
  children,
  className,
}: PageHeaderVisualProps): JSX.Element {
  return (
    <div
      data-slot="page-header-visual"
      className={clsx(styles.visual({ variant }), className)}
    >
      {icon ? <Icon name={icon} /> : children}
    </div>
  );
}
